module.exports = __webpack_public_path__ + "static/media/marsAdventureScreenshot.c4860216.jpg";